import { fuego } from '@store/firebase';
import { deleteImgStorage } from '@store/firebase/storage';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { IcommentItem } from '@typings/common/comment.interface';
import { COUPLE_SUB_COL_VALUE } from '@typings/couple/coupleSubCol';

interface Props {
  docId: string;
  collectionPath: string;
}

export async function deleteCouple({ docId, collectionPath }: Props) {
  const ref = fuego.db.collection(collectionPath);
  // 모든 img 지워야함..? wow....

  return ref.doc(docId).delete();
}
type deleteImageProps = {
  imgURL: string;
  collectionPath: string;
  docId: string;
  key:
    | 'leftHeadImgURL'
    | 'leftBodyImgURL'
    | 'rightHeadImgURL'
    | 'rightBodyImgURL'
    | 'mainImgURL'
    | 'moneyImgURL'
    | 'logoImgURL'
    | 'imgURL'
    | 'backgroundImgURL';
};

export async function deleteImage({
  imgURL,
  collectionPath,
  docId,
  key,
}: deleteImageProps) {
  const ref = fuego.db.collection(collectionPath);

  if (imgURL) deleteImgStorage(imgURL);
  return ref.doc(docId).set({ [key]: '' }, { merge: true });
}

export async function deleteSectionImg({
  collectionPath,
  imgURL,
  subCol,
  subId,
  docId,
}) {
  const rootRef = fuego.db.collection(collectionPath).doc(docId);
  if (imgURL) deleteImgStorage(imgURL);
  return rootRef
    .collection(subCol)
    .doc(subId)
    .set({ imgURL: '' }, { merge: true });
}

export async function deleteThumbnail({
  collectionPath,
  docId,
  data,
  key,
}: {
  collectionPath: string;
  docId: string;
  data: {
    order: number;
    imgURL: string;
  };
  key: 'left' | 'right';
}) {
  const ref = fuego.db.collection(collectionPath);
  if (data.imgURL) deleteImgStorage(data.imgURL);

  return ref.doc(docId).set(
    {
      character: {
        [key]: {
          thumbnails: firebase.firestore.FieldValue.arrayRemove(data),
        },
      },
    },
    { merge: true },
  );
}

export async function deleteItem({
  collectionPath,
  docId,
  subCol,
  subId,
  data,
}: {
  collectionPath: string;
  docId: string;
  subCol: COUPLE_SUB_COL_VALUE;
  subId: string;
  data: any;
}) {
  const rootRef = fuego.db.collection(collectionPath).doc(docId);
  if (data.imgURL) deleteImgStorage(data.imgURL);
  return rootRef.collection(subCol).doc(subId).delete();
}
